<template>
  <vs-row>
    <!-- <pre> {{ filesInfo }}</pre> -->
    <!-- {{section_type}} -->
    <!-- {{file_repository_id}} -->
    <!-- Browse Content -->
    <div v-if="isBrowseContent">
      <vs-popup fullscreen title="Browse Item" :active.sync="isBrowseContent" class="childImportPopUp">
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="file_repository_id"
          @getImportFile="getImportFile"
        ></import-browse-files-model>
        <div slot="footer">jfjfjf</div>
      </vs-popup>
    </div>
    <!-- Browse Content -->
    <!-- {{file_repository_id}} -->
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
      <vs-card class="cstm-card w-full mb-4 collapse-cstm-card">
        <div class="collapse-item">
          <div
            class="flex justify-between header"
            slot="header"
            @click="isCollapseCard = !isCollapseCard"
            :class="{ activeCollapse: isCollapseCard }"
          >
            <h5>Files</h5>
            <span class="material-icons">keyboard_arrow_down</span>
          </div>
          <div
            class="collapseContent"
            v-show="isCollapseCard"
            :class="{ active: isCollapseCard }"
          >
            <vs-button
              v-if="section_type != 'courseHeader'"
              class="mb-2"
              color="dark"
              type="filled"
              icon="menu"
              @click.prevent="switchTheme"
            >
              <span v-if="theme != 'list'">List View</span>
              <span v-if="theme == 'list'">Grid View</span>
            </vs-button>

            <!-- <pre>{{fileRecords}}</pre> -->

            <!-- {{lesson_file_index}} -->
            <!-- {{imagevalidation}} -->
            <VueFileAgent
              ref="vueFileAgent"
              :theme="theme"
              :multiple="multiplefile"
              :deletable="true"
              :meta="true"
              :accept="imagevalidation"
              :maxSize="'10000MB'"
              :maxFiles="14"
              :linkable="true"
              :helpText="imageHint"
              :errorText="{
                type: 'Invalid file type. Only images Allowed',
                size: 'Files should not exceed 10MB in size',
              }"
              @select="filesSelected($event)"
              @beforedelete="onBeforeDelete($event)"
              @delete="fileDeleted($event)"
              v-model="fileRecords"
              @upload:error="uploadEvent('upload:error', $event)"
            ></VueFileAgent>

            <div v-if="fileRecordsForUpload.length">
              <vs-divider />
              <vs-button
                :disabled="!fileRecordsForUpload.length"
                @click="uploadFiles()"
              >
                Upload {{ fileRecordsForUpload.length }} files
              </vs-button>
            </div>

            <!-- <pre>{{fileRecordsForUpload}}</pre>
    <pre>{{fileRecords}}</pre> -->
          </div>
        </div>
        <vs-button
          @click="isBrowseContent = true"
          class="flex flex-end"
          v-if="section_type !== 'courseHeader'"
        >
          Browse From Existing Files
        </vs-button>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import { getUploadedFilesId } from '@/api/assignment-question'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
export default {
  name: 'FileTesting',
  components: { ImportBrowseFilesModel },
  props: {
    section_type: {
      required: true,
      type: String,
      default: ''
    },
    multiplefile: {
      required: true,
      type: Boolean,
      default: false
    },
    lesson_file_index: {
      required: false,
      type: Number,
      default: 0
    },
    file_repository_id: {
      required: false,
      type: Number,
      default: 0
    },
    filesInfo: {
      required: false,
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      deletedIndex: null,
      isBrowseContent: false,
      isCollapseCard: true,
      theme: 'grid',
      imageHint: 'Choose files or drag & drop here',
      imagevalidation: '',
      auto: true,
      fileRecords: [],
      uploadUrl: '',
      ///file/upload/${platform_customer_id}
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: [],
      importedFileData: [] // maintain an upload queue
    }
  },
  // config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`

  async created () {

    const customer_id = await this.$store.getters.customerId
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.uploadUrl = `${imageUploadUrl}${customer_id}`
    this.uploadHeaders.Authorization = `Bearer ${JSON.parse(
      localStorage.getItem('access_token')
    )}`
    if (this.section_type === 'courseHeader') {
      this.imagevalidation = 'image/*'
      this.imageHint = 'Choose course image or drag & drop here'
    }
  },
   mounted () {
     console.log("hello", this.filesInfo)
    if (this.filesInfo.length) {
      this.fileRecords =  this.filesInfo.map((ele) => {
        return {
          'name':ele.file_name,
          'sizeText':this.bytesToSize(ele.size),
          'size':ele.size,
          'type':ele.file_type,
          'url':ele.file_path
        }
      })
    }
    /*const vuecomp = Vue.extend(BrowseComponentDesign)
    const component = new vuecomp().$mount()

    const list = this.$refs.vueFileAgent.$el.getElementsByClassName('file-preview-wrapper')


    list[0].insertBefore(component.$el, list[0])

    this.$refs.vueFileAgent.$el.parentNode.insertBefore(component.$el, list[0].nextSibling)
     */
  },
  methods: {
    switchTheme () {
      this.theme = this.theme === 'list' ? 'default' : 'list'
    },
    uploadEvent (eventName, data) {

    },
    uploadFiles () {


      // Using the default uploader. You may use another uploader instead.
      // const data = this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload)

      //

      const data = this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload,
        function createFormData (fileData) {


          const formData = new FormData()
          formData.append('files[]', fileData.file) // this is important! - the actual file for upload
          return formData // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
        }
      )


      this.$vs.loading({
        type: 'material',
        text: 'Please wait we are uploading files'
      })

      data
        .then((response, error) => {

          const cdn = response[0].data.data.cdn
          if (response) {
            for (let i = 0; i < response.length; i++) {
              const file_name = response[i].data.data.files[0].file_name
              const file_path = response[i].data.data.files[0].file_path


              const raw = JSON.stringify({
                file_repository_id: this.file_repository_id,
                files: [
                  {
                    file_name,
                    file_path: `${cdn}${file_path}`
                  }
                ]
              })

              const file_id_payload = raw

              this.getUploadFiles(file_id_payload)
            }
          } else {

            this.$vs.loading.close()
          }
        })
        .catch((error) => {
          this.$vs.loading.close()


        })
        .finally(this.$vs.loading.close())
      this.fileRecordsForUpload = []
    },
    deleteUploadedFile () {
      if (
        this.section_type === 'courseHeader' ||
        this.section_type === 'CourseComponent'
      ) {
        this.$emit('deletedIndex', this.deletedIndex)
      } else if (
        this.section_type === 'lessonComponent' ||
        this.section_type === 'topiccomponent'
      ) {
        const fileIdObject = {
          lesson_file_index: this.lesson_file_index,
          fileIndex: this.deletedIndex
        }
        this.$emit('deletedIndex', fileIdObject)
      }
    },
    filesSelected (fileRecordsNewlySelected) {


      const validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      )


      if (this.section_type === 'courseHeader') {
        this.fileRecordsForUpload = fileRecordsNewlySelected
        if (!validFileRecords.length) {
          this.fileRecordsForUpload.length = 0
        }
      } else {
        // this.imagevalidation = ''

        this.fileRecordsForUpload = this.fileRecordsForUpload.concat(
          validFileRecords
        )
      }
    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure you want to delete this file?',
          accept: this.acceptAlert,
          parameters: fileRecord
        })
      }
    },
    acceptAlert (fileRecord) {
      const index = this.fileRecords.indexOf(fileRecord)

      this.deletedIndex = index


      this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event

      // this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
    },
    fileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.deleteUploadedFile(fileRecord)
      }
    },
    async getUploadFiles (file_id_payload) {
      const res = await getUploadedFilesId(file_id_payload)

      if (res.data.message === 'files.createFile') {


        /* const newRecord = this.generateFileForVueAgent(response[i].data.data.files[0])

               */
        const file = {
          file: res.data.data.files[0]
        }
        this.filesInfo.push(file)

        const file_id = res.data.data.files[0].files_id
        this.$vs.notify({
          title: 'Success',
          text: 'File Uploaded Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 1000
        })
        //

        // const fileIdObject = {
        //   question_index:this.question_detail_index,
        //   file_id
        // }

        this.$vs.loading.close()

        //section type checking '
        if (this.section_type === 'courseHeader') {
          this.$emit('getFileIdHeader', file_id)
        } else if (this.section_type === 'CourseComponent') {
          this.$emit('getFileId', file_id)
        } else if (
          this.section_type === 'lessonComponent' ||
          this.section_type === 'topiccomponent'
        ) {
          const fileIdObject = {
            lesson_file_index: this.lesson_file_index,
            file_id
          }


          this.$emit('getFileId', fileIdObject)
        }

        //section type checking
      }
    },
    bytesToSize (bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
    },
    getImportFile ({ file_id, fileInfo }) {

      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)
      if (this.section_type === 'courseHeader') {

        this.$emit('getFileIdHeader', file_id)
      } else if (this.section_type === 'CourseComponent') {
        const importFileRecords = this.getImportedFile(fileInfo)

        this.filesInfo.push(
          ...importFileRecords.map((ele) => {
            return {
              file: {
                'file_name': ele.name,
                'file_path': ele.url,
                'size': ele.size,
                'file_type': ele.type
              }
            }
          })
        )

        this.fileRecords.push(...importFileRecords)

        this.$emit('getFileId', file_id)
      } else if (
        this.section_type === 'lessonComponent' ||
        this.section_type === 'topiccomponent'
      ) {
        const fileIdObject = {
          lesson_file_index: this.lesson_file_index,
          file_id
        }
        const importFileRecords = this.getImportedFile(fileInfo)

        this.fileRecords.push(...importFileRecords)


        this.$emit('getFileId', fileIdObject)
      }
    },
    generateFileForVueAgent (ele) {
      return {
        file_id: ele.file.id,
        name: ele.file.file_name,
        sizeText: this.bytesToSize(ele.file.size),
        size: ele.file.size,
        type: ele.file.file_type,
        url: ele.file.file_path,
        upload: {
          data: true,
          error: false
        }
      }
    },
    getImportedFile (fileInfo) {
      return fileInfo.map((ele) => {
        return {
          name: ele.file_name,
          sizeText: this.bytesToSize(ele.size),
          size: ele.size,
          type: ele.file_type,
          url: ele.file_path,
          color: 'green',
          upload: {
            data: true,
            error: false
          }
        }
      })
    }
  }
}
</script>
<style>
.childImportPopUp{
  z-index: 53001;

}
</style>
